/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.money_format_no_decimals = "${{amount_no_decimals}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('variant:changed', function(event) {
	console.log('variant:changed', event.detail);
	var variant = event.detail.variant; // Gives you access to the whole variant details
	var productStockMessage = document.getElementsByClassName('ProductStockMessage');
	var quickShipButton = document.getElementsByClassName('quickShip out-of-stock');
	// console.log(variant.available, variant.inventory_quantity, variant);
	var productMetaPrices = document.querySelector('.ProductMeta__PriceList');
	var productDiscount = productMetaPrices ? productMetaPrices.getAttribute('data-sale') : null;	
	// console.log(productDiscount);
	
	// Update stock message
	if (productStockMessage.length) {
		var inMessage = productStockMessage[0].getAttribute('data-in'),
			outMessage = productStockMessage[0].getAttribute('data-out');
		if (variant && variant.available) {
			if (variant.inventory_quantity > 0) {
				productStockMessage[0].textContent = inMessage;
				// console.log('In Stock', inMessage);
			} else {
				productStockMessage[0].textContent = outMessage;
				// console.log('Out of Stock', inMessage);
			}
			if (quickShipButton.length) {
				quickShipButton[0].style.display = 'none';
			}
		} else {
			productStockMessage[0].textContent = '';
			if (quickShipButton.length) {
				quickShipButton[0].style.display = 'block';
			}
		}
	}

	// Update price and shop pay widget
	if (variant) {
		// Update prices for all price elements
		updateProductPrices(variant, productDiscount);
		
		// Refresh the Shop Pay widget when variant changes
		setTimeout(refreshShopPayWidget, 150);
	}

	if (event.detail.updateAddToCartButton) {
		var addToCartButton = document.querySelector('.ProductForm__AddToCart');
		if(!variant) {
			addToCartButton.setAttribute('disabled', 'disabled');
			addToCartButton.removeAttribute('data-action');
			addToCartButton.classList.add('Button--secondary');
			addToCartButton.innerHTML = window.languages.productFormUnavailable;
		} else {
			if (variant.available) {
				addToCartButton.removeAttribute('disabled');
				addToCartButton.classList.add('Button--primary');
				addToCartButton.setAttribute('data-action', 'add-to-cart');
				addToCartButton.innerHTML = window.languages.productFormAddToCart;
			} else {
				addToCartButton.setAttribute('disabled', 'disabled');
				addToCartButton.classList.add('Button--secondary');
				addToCartButton.removeAttribute('data-action');
				addToCartButton.innerHTML = window.languages.productFormSoldOut;
			}

			//selects the selected variant
			const productFormOptionsSelectBox = document.querySelector('.Product__Info .ProductForm__Option select');
			if (productFormOptionsSelectBox) {
				productFormOptionsSelectBox.value = event.detail.variant.id;
			}
		}
	}

	var backInStock = document.getElementById('back-in-stock');
	if (backInStock) {
		var variantInput = document.getElementsByName('contact[variant]');
		if (variantInput.length) {
			variantInput[0].value = variant.title;
			if (!variant.available) {
				backInStock.style.display = 'block';
			} else {
				backInStock.style.display = 'none';
			}
		} else {
			backInStock.style.display = 'none';
		}
	}
	
    if(typeof original_price_percent != 'undefined'){
      let current_price = parseFloat(document.querySelector('.ProductMeta__Price').innerText.replace('$',''));
      let newPrice = current_price * original_price_percent;
      document.getElementById('original_price').innerText = '$' + newPrice.toFixed(2);
    }
});

// Function to update product prices when variant changes
function updateProductPrices(variant, productDiscount) {
	if (!variant) return;
	
	// Update main product meta prices
	var productMetaPrices = document.querySelector('.ProductMeta__PriceList');
	if (productMetaPrices) {
		if (productDiscount) {
			// Handle discounted products
			productMetaPrices.innerHTML = '';
			productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(variant.price * productDiscount, Shopify.money_format_no_decimals) + '</span>';
			productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(variant.price,  Shopify.money_format_no_decimals) + '</span>';
		} else {
			// Handle non-discounted products
			productMetaPrices.innerHTML = '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(variant.price,  Shopify.money_format_no_decimals) + '</span>';
		}
		productMetaPrices.style.display = '';
	}
}

var productImageElement = document.getElementsByClassName('Product__Gallery');
if (productImageElement.length) {
	var productNavElement = document.getElementsByClassName('Product__SlideshowNav--thumbnails Carousel');
	if (productNavElement.length) {
		var productNavCarouselElem = document.querySelector('.Carousel .Product__SlideshowNavScroller');
		var flkty = new Flickity( productNavCarouselElem, {
			prevNextButtons: true,
			pageDots: false,
			wrapAround: false,
			cellAlign: 'left',
			groupCells: 4
		});
	}
}

// Function to refresh Shop Pay widget
function refreshShopPayWidget() {
	var shopifyPaymentButton = document.querySelector('.shopify-payment-button');
	
	if (!shopifyPaymentButton) {
		return;
	}
	
	// Method 1: Try to re-initialize the payment button
	if (window.Shopify && window.Shopify.PaymentButton) {
		try {
			window.Shopify.PaymentButton.init();
			return;
		} catch (e) {
			console.log('Shop Pay widget re-initialization failed, trying alternative method');
		}
	}
	
	// Method 2: Remove and recreate the payment button
	try {
		// Clear the existing payment button
		shopifyPaymentButton.innerHTML = '';
		
		// Trigger a custom event for other scripts
		var refreshEvent = new CustomEvent('shopify:payment-button:refresh', {
			detail: { timestamp: Date.now() }
		});
		document.dispatchEvent(refreshEvent);
		
		// Re-initialize after a short delay
		setTimeout(function() {
			if (window.Shopify && window.Shopify.PaymentButton) {
				window.Shopify.PaymentButton.init();
			}
		}, 100);
	} catch (e) {
		console.log('Shop Pay widget refresh failed:', e);
	}
}